"use strict";
import Button from "./Button";
import Application from "./Application";

function Common() {
}
export default Common;

Common.cameraShake = null;

Common.hearts = [];

Common.healthInLevel = false;

Common.gameScene = null;
Common.world = null;

Common.uiLayer = null;

Common.getMultiPanelPos = function () {
    const x = (Common.STAGE_WIDTH - P3.View.width) * 0.5 + 445, y = 42;
    return new PIXI.Point(x, y);
};

/**
 * @type {null}
 */
Common.scoreManager = null;

/**
 * Pans to right, left or centre.
 * @abstract
 * @param str {string}
 * @return {boolean}
 */
Common.panGameScene = (str) => {
    // "override" in game scene
    throw new Error('must be implemented in game scene!');
};

/**
 * @type {Array}
 */
Common.activePathIds = [];

/**
 * @param arr
 */
Common.buttonsAppear = function (arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            delay: i * 0.2 + 0.25
        });
    }
};

/**
 * @type {null}
 */
Common.barMaxFill = null;

/**
 * @deprecated
 * @type {boolean}
 */
Common.inPuzzle = false;

/**
 * @deprecated
 * @type {Array}
 */
Common.generatedDispObjs = [];

/**
 * @type {number}
 */
Common.highestScore = 0;

/**
 * @type {{}}
 */
Common.results = {};

/**
 * @type {null}
 */
Common.assets = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * Semi unique key used as an identifier for save files, followed by the version
 * (useful if you want players to start a new game, increment version number)
 * @type {string}
 */
Common.game_key = "sjroki1muk-cnt-00918-gold-v2";

/**
 * @type {P3.View}
 */
Common.view = null;

/**
 * @type {P3.Tracking}
 */
Common.tracking = null;

/**
 * @type {AudioManager}
 * @static
 */
Common.audio = null;

/**
 * @type {P3.Camera}
 * @static
 */
Common.camera = null;

/**
 * @type {Player}
 */
Common.player = null;

/**
 * @type {number}
 */
Common.paused = false;

/**
 * @deprecated
 * @type {number}
 */
Common.gameRunning = false;

/**
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 */
Common.isDebug = false;

/**
 * @type {boolean}
 */
Common.isMute = false;

//===============//
//==static vars==//
//===============//

/**
 * @type {object}
 * @static
 */
Common.copy = null;

/**
 * @type {object}
 * @static
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_WIDTH = 1664;

/**
 * @type {number}
 * @static
 * @const
 */
Common.STAGE_HEIGHT = 768;

/**
 * @type {PIXI.Container}
 * @static
 */
Common.stage = null;

/**
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 * @static
 */
Common.renderer = null;

//===============//
//==static ends==//
//===============//

//================================//
//=====save and load functions====//
//================================//

Common.saveMute = function () {
    const data = {
        isMute: Common.isMute
    };
    localStorage.setItem(Common.game_key + "_isMute", JSON.stringify(data));
};

Common.loadMute = function () {
    //if the data exists get it
    const data = JSON.parse(localStorage.getItem(Common.game_key + "_isMute"));
    if (data) {
        Common.isMute = data.isMute;
        Common.audio.mute(Common.isMute);
    }
};

Common.saveGame = function () {
    const gameData = {
        highestScore: Common.highestScore
    };
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    //if the data exists get it
    const gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.highestScore = gameData.highestScore;
        Common.isFirstPlay = false;
    } else Common.isFirstPlay = true;
};

//=========================================================//
//=============Rest is all util type functions=============//
//=========================================================//

/**
 * Creates and returns a new button
 * @param x - Coordinate
 * @param y - Coordinates
 * @param type - Button type
 * @param clickFunc - Target function
 * @param scope  -This context
 * @param holder - Display container optional arg]
 * @param text - For prototyping can add a bit of text to generic button
 * @param icon
 * @returns {Button}
 */
Common.createButton = function (x, y, type, clickFunc, scope, holder, text, icon) {

    var states = new P3.ButtonStates();

    if (text || type === null || type === undefined) {
        states.normal = PIXI.Texture.EMPTY;
        states.down = PIXI.Texture.EMPTY;
    } else if (typeof type === "string") {
        states.normal = Common.assets.texture("btn_" + type + "_out");//meant to be "_up"
        //  states.over = Common.assets.getTexture("btn_" + type + "_over");
        states.down = Common.assets.texture("btn_" + type + "_down");
    } else {
        states.normal = type;
    }

    let button = new Button(states, this);
    button.x = x;
    button.y = y;
    button.anchor = new PIXI.Point(0.5, 0.5);
    button.animate = true;

    button.signals.click.add(clickFunc, scope);

    if (holder) holder.addChild(button);
    if (text) {

        let txtView = P3.simpleText(text, "consolas", 100, button, 0xffffff);//new PIXI.extras.BitmapText(text, {font: "45px Calibri"});
        txtView.anchor = {x: 0.5, y: 0.5};
        button.txtView = txtView;
    }

    if (icon) {
        let sp = new PIXI.Sprite(Common.assets.texture(icon));
        sp.anchor.set(0.5);
        button.addChild(sp);
        button.icon = sp;
    }

    return button;
};

/**
 * Knuth shuffle variation
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    const a = string.split(""); //our array
    const n = a.length; //number of elements
    for (var i = n - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = (a) => {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    return Math.atan2(dy, dx);
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

Common.rad2deg = function (rad) {
    return rad * 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * Uses oriented bounding box (OBB) to check collisions with optional tuning arg to make bounds bigger or smaller
 * @param r1
 * @param r2
 * @param scale
 * @returns {boolean}
 */
Common.collisionOBB = function (r1, r2, scale) {
    if (!scale || scale <= 0) scale = 1;
    r1 = r1.getBounds();
    r2 = r2.getBounds();

    return !(r2.x > (r1.x + r1.width * scale) ||
    (r2.x + r2.width * scale) < r1.x ||
    r2.y > (r1.y + r1.height * scale) ||
    (r2.y + r2.height * scale) < r1.y);
};

/**
 * Returns a new keyboard object that listens for keyboard input
 * @param keyCode
 * @returns {{}}
 */
Common.keyboard = function (keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.down = undefined;
    key.up = undefined;
    //The `downHandler`
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.down) key.down();
            key.isDown = true;
            key.isUp = false;
        }
        event.preventDefault();
    };

    //The `upHandler`
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.up) key.up();
            key.isDown = false;
            key.isUp = true;
        }
        event.preventDefault();
    };

    //Attach event listeners
    window.addEventListener(
        "keydown", key.downHandler.bind(key), false
    );
    window.addEventListener(
        "keyup", key.upHandler.bind(key), false
    );
    return key;
};

Common.genTex = function (width, height, colour, shape) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0x000fff);
    if (shape === "rect") g.drawRect(0, 0, width, height);
    else if (shape === "circle") g.drawEllipse(0, 0, width, height);
    else g.drawRect(0, 0, width, height);//fallback to rect
    g.endFill();
    return Common.renderer.generateTexture(g);
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - should we return a texture or a sprite?
 * @returns {PIXI.Sprite|String}
 */
Common.generateRect = function (width, height, colour, retTexture) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0x000fff);
    g.lineStyle(5, 0xd9d9d9);
    g.drawRect(0, 0, width, height);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0.5};
    g.destroy();
    if (!retTexture) return sprite;
    sprite.destroy();
    return texture;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - Should we return a texture or a sprite?
 * @returns {PIXI.Sprite|PIXI.Texture}
 */
Common.generateEllipse = function (width, height, colour, retTexture) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0xfff000);
    g.drawEllipse(0, 0, width, height);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0.5};
    g.destroy();
    if (!retTexture) return sprite;
    else return texture;
};

/**
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (let i = 0; i < arguments.length; i++) {
        arguments[i].anchor = {x: 0.5, y: 0.5};
    }
};

/**
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    var arr = [];
    for (var i = 0; i < numRows; i++) {
        var columns = [];
        for (var j = 0; j < numCols; j++) columns[j] = initial;
        arr[i] = columns;
    }
    return arr;
};

/**
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    var arr = [];
    for (var i = 0; i < size; i++) arr.push(initial);
    return arr;
};

/**
 * Uses quick sort to sort an array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sort = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i] < pivot) swap(index++, i);
                else if (highToLow && array[i] > pivot)swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts array of objects that have a score property, bit unnecessary function..
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sortByScore = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i].score < pivot.score) swap(index++, i);
                else if (highToLow && array[i].score > pivot.score)swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Uses quick sort to sort 2d array by length of 2nd array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sortByArrLen = function (array, highToLow) {
    var size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow && array[i].length < pivot.length) swap(index++, i);
                else if (highToLow && array[i].length > pivot.length)swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts tiles (or any display object) by x, y coordinates so they are ordered lowest top to bottom , left to right
 * @param array
 * @returns {*}
 */
Common.sortTiles = function (array) {
    array.sort(function (a, b) {
        if (a.y == b.y) return a.x - b.x;
        return a.y - b.y;
    });
    return array;
};

/**
 * Sorts object with an x or y property (such as sprites) by x or y dependant on flag
 * @param array - array to sort
 * @param highToLow - sort high to low?
 * @param x - flag to choose whether to sort by x or y
 * @returns {*}
 */
Common.sortBy = (array, highToLow, x) => {
    var size = array.length - 1;
    quickSort(0, size);
    return array;
    function quickSort(first, last) {
        if (first < last) {
            var pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }
        function swap(p, q) {
            var temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            var pivot = array[first], index = first;
            swap(index, last);
            for (var i = first; i < last; i++) {
                if (!highToLow) {
                    if (x) {
                        if (array[i].x < pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y < pivot.y) swap(index++, i);
                    }
                }
                else {
                    if (x) {
                        if (array[i].x > pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y > pivot.y) swap(index++, i);
                    }
                }
            }
            swap(index, last);
            return index;
        }
    }
};

Common.compareXY = function (point1, point2) {
    return (Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y));
};

Common.compareX = function (point1, point2) {
    return (Math.round(point1.x) === Math.round(point2.x));
};

//--from stackoverflow-- https://stackoverflow.com/questions/14962018/detecting-and-fixing-circular-references-in-javascript //
Common.detectCircularRef = function (obj) {

    return detectCircularReferences(obj);

    function detectCircularReferences(toBeStringifiedValue, serializationKeyStack = []) {
        Object.keys(toBeStringifiedValue).forEach(key => {
            var value = toBeStringifiedValue[key];
            var serializationKeyStackWithNewKey = serializationKeyStack.slice();
            serializationKeyStackWithNewKey.push(key);
            try {
                JSON.stringify(value);
            }
            catch (error) {
                var isCircularValue;
                var circularExcludingStringifyResult = "";
                try {
                    circularExcludingStringifyResult = JSON.stringify(value, replaceRootStringifyReplacer(value), 2);
                    isCircularValue = true;
                }
                catch (error) {
                    detectCircularReferences(value, serializationKeyStackWithNewKey);
                    isCircularValue = false;
                }
                if (isCircularValue) {
                    throw new Error(`Circular reference detected:\nCircularly referenced value is value under path "${joinStrings(serializationKeyStackWithNewKey)}" of the given root object\n` +
                        `Calling stringify on this value but replacing itself with [Circular object --- fix me] ( <-- search for this string) results in:\n${circularExcludingStringifyResult}\n`);
                }
            }
        });
    }

    function replaceRootStringifyReplacer(toBeStringifiedValue) {
        var serializedObjectCounter = 0;
        return function (key, value) {
            if (serializedObjectCounter !== 0 && typeof (toBeStringifiedValue) === 'object' && toBeStringifiedValue === value) {
                return '[Circular object --- fix me]';
            }
            serializedObjectCounter++;
            return value;
        };
    }

    function joinStrings(arr, separator = ":") {
        if (arr.length === 0)
            return "";
        return arr.reduce((v1, v2) => `${v1}${separator}${v2}`);
    }
};

//from github pixi-simple-gestures
Common.pinchable = function (sprite, inertia) {

    console.log("making pinchable");
    sprite.interactive = true;
    sprite.on('touchstart', start);
    sprite.on('touchend', end);
    sprite.on('touchendoutside', end);

    function start(e) {
        sprite.on('touchmove', move)
    }

    function move(e) {
        let t = e.data.originalEvent.targetTouches;
        if (!t || t.length < 2) {
            return
        }
        let dx = t[0].clientX - t[1].clientX;
        let dy = t[0].clientY - t[1].clientY;
        let distance = Math.sqrt(dx * dx + dy * dy);
        if (!sprite._pinch) {
            sprite._pinch = {
                p: {
                    distance: distance,
                    date: new Date()
                }
            };
            sprite.emit('pinchstart');
            return
        }
        let now = new Date();
        let interval = now - sprite._pinch.p.date;
        if (interval < 12) {
            return
        }
        let center = {
            x: (t[0].clientX + t[1].clientX) / 2,
            y: (t[0].clientY + t[1].clientY) / 2
        };
        let event = {
            scale: distance / sprite._pinch.p.distance,
            velocity: distance / interval,
            center: center,
            data: e.data
        };
        sprite.emit('pinchmove', event);
        sprite._pinch.pp = {
            distance: sprite._pinch.p.distance,
            date: sprite._pinch.p.date
        };
        sprite._pinch.p = {
            distance: distance,
            date: now
        }
    }

    function end(e) {
        sprite.removeListener('touchmove', move);
        if (!sprite._pinch) {
            return
        }
        if (inertia && sprite._pinch.pp) {
            if (sprite._pinch.intervalId) {
                return
            }
            let interval = new Date() - sprite._pinch.p.date;
            let velocity = (sprite._pinch.p.distance - sprite._pinch.pp.distance) / interval;
            let center = sprite._pinch.p.center;
            let distance = sprite._pinch.p.distance;
            sprite._pinch.intervalId = setInterval(() => {
                if (Math.abs(velocity) < 0.04) {
                    clearInterval(sprite._pinch.intervalId);
                    sprite.emit('pinchend');
                    sprite._pinch = null;
                    return
                }
                let updatedDistance = distance + velocity * 12;
                let event = {
                    scale: updatedDistance / distance,
                    velocity: velocity,
                    center: center,
                    data: e.data
                };
                sprite.emit('pinchmove', event);
                distance = updatedDistance;
                velocity *= 0.8;
            }, 12)
        } else {
            sprite.emit('pinchend');
            sprite._pinch = null
        }
    }
};

//from https://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
Common.getAndroidVersion = function (ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    var match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

/**
 * Custom tween
 * @param obj
 * @param time
 * @param params
 * @returns {TweenLite|TweenMax|TimelineLite|*}
 */
Common.erraticTween = function (obj, time, params = {delay: 0}) {
    params.ease = CustomEase.create("custom", "M0,0,C0,0,0.065,0.167,0.08,0.205,0.09,0.2,0.124,0.182,0.135,0.176,0.157,0.223,0.21,0.59,0.22,0.608,0.223,0.585,0.298,0.12,0.3,0.111,0.3,0.118,0.309,0.262,0.315,0.345,0.322,0.36,0.325,0.372,0.335,0.388,0.352,0.417,0.372,0.439,0.39,0.463,0.391,0.502,0.394,0.58,0.395,0.583,0.396,0.578,0.418,0.461,0.43,0.399,0.431,0.397,0.463,0.611,0.464,0.61,0.475,0.621,0.488,0.448,0.495,0.455,0.495,0.449,0.498,0.417,0.5,0.404,0.512,0.401,0.562,0.262,0.572,0.26,0.577,0.293,0.568,0.499,0.58,0.568,0.597,0.639,0.603,0.787,0.608,0.806,0.616,0.794,0.698,0.64,0.705,0.63,0.705,0.638,0.708,0.685,0.71,0.72,0.711,0.734,0.713,0.745,0.715,0.756,0.719,0.759,0.737,0.781,0.742,0.784,0.746,0.83,0.743,0.912,0.745,0.925,0.756,0.907,0.863,0.732,0.88,0.705,0.894,0.741,1,1,1,1");
    return TweenMax.to(obj, time, params);
};

window.Common = Common;
